import { WorkflowPlanAutomation } from '@ebalance/proto/bffuser/v1/workflow_auto_creation_rule_model_pb'

const K = 'page:adminWorkflowTemplates.autoCreationRule'

type SelectablePlanAutomation = Exclude<
  WorkflowPlanAutomation,
  WorkflowPlanAutomation.UNSPECIFIED
>

const PLAN_AUTOMATION_OPTIONS: readonly SelectablePlanAutomation[] = [
  WorkflowPlanAutomation.SAME_AS_TEMPLATE,
  WorkflowPlanAutomation.AUTO_SUBMIT,
  WorkflowPlanAutomation.CREATE_ONLY,
]

const PLAN_AUTOMATION_LABEL_KEYS: Record<SelectablePlanAutomation, string> = {
  [WorkflowPlanAutomation.SAME_AS_TEMPLATE]: `${K}.planAutomation.sameAsTemplate`,
  [WorkflowPlanAutomation.AUTO_SUBMIT]: `${K}.planAutomation.autoSubmit`,
  [WorkflowPlanAutomation.CREATE_ONLY]: `${K}.planAutomation.createOnly`,
}

/**
 * 計画の自動化の欄の状態 (AC-WFT-043)。雛形の計画を提出するサブステップに要承認が
 * あれば (backend の lock 判定) 選べるのは雛形どおりだけ。
 */
export type PlanAutomationField =
  | { kind: 'choosable'; options: readonly SelectablePlanAutomation[] }
  | { kind: 'locked'; options: readonly SelectablePlanAutomation[] }

export function planAutomationField(locked: boolean): PlanAutomationField {
  return locked
    ? { kind: 'locked', options: [WorkflowPlanAutomation.SAME_AS_TEMPLATE] }
    : { kind: 'choosable', options: PLAN_AUTOMATION_OPTIONS }
}

/**
 * 保存値の意味。UNSPECIFIED・知らない値は backend が上書きしないので雛形どおり
 * (一覧の表示も編集の初期値もこれに揃え、送れない 0 を form に持ち込まない)。
 */
export function effectivePlanAutomation(
  value: WorkflowPlanAutomation,
): SelectablePlanAutomation {
  return value in PLAN_AUTOMATION_LABEL_KEYS
    ? (value as SelectablePlanAutomation)
    : WorkflowPlanAutomation.SAME_AS_TEMPLATE
}

/** 保存値のラベル (`effectivePlanAutomation` の表示名)。 */
export function planAutomationLabelKey(value: WorkflowPlanAutomation): string {
  return PLAN_AUTOMATION_LABEL_KEYS[effectivePlanAutomation(value)]
}
